/**
 * Liste des comptes Lamotte
 * Ajouté dans le cadre d'une fonctionnalité spécifique pour afficher les annonces validées
 * (j'ai ajouté l'annonceur de démo 351951 pour avoir accès à la fonctionnalité)
 */

export default {
  namespaced: true,
  state: {
    advertisers: [351951, 442284, 351966, 351968, 561382, 352406]
  },
  getters: {
    getAdvertisers: (state) => {
      return state.advertisers
    }
  }
}
